import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import projectReducer from './project/projectSlice';
import workflowReducer from './workflow/workflowSlice';
import connectionsReducer from './connectionsSlice';
import authReducer from './authSlice';
import dataDefinitionsReducer from './dataDefinitionsSlice';
import { historyMiddleware } from './workflow/historyMiddleware';
import { usageLogMiddleware } from './usageLogMiddleware';

const rootReducer = combineReducers({
  auth: authReducer,
  project: projectReducer,
  workflow: workflowReducer,
  connections: connectionsReducer,
  dataDefinitions: dataDefinitionsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  }).concat(historyMiddleware, usageLogMiddleware),   // 캔버스 언두/리두 기록 · 기능 사용 기록
});

// 개발 편의: 브라우저 콘솔/E2E 스크립트에서 상태를 들여다보고 액션을 쏠 수 있게 노출 (운영 빌드 제외)
if (process.env.NODE_ENV === 'development') {
  (window as any).__openflowStore = store;
}

export default store; 